import { createContext } from 'react';
export const StatusDataContext = createContext({
    productAttributeCodes: [],
    statusDefinitionList: [],
    legacyPref: false,
    setLegacyPref: (val) => { },
});
export default StatusDataContext;
